import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Reviewer } from '@shared/interfaces/CommonInterfaces';

type ReviewStatusChipProps = {
  reviewers?: Reviewer[];
}

function ReviewStatusChip(props: ReviewStatusChipProps) {
  return <>
    {props.reviewers?.map((reviewer: Reviewer) => (
      <Stack key={reviewer.name} direction="row" spacing={1} sx={{ margin: "4px" }}>
        <Tooltip title={reviewer.vote > 0 ? "Approved" : reviewer.vote === 0 ? "No review yet" : "Rejected"} placement="right" arrow>
          <Chip sx={{
            "& .MuiChip-deleteIcon": {
              cursor: "default"
            },
            "&:hover": {
              "& .MuiChip-deleteIcon": {
                color: "rgba(0, 0, 0, 0.26)"
              }
            }
          }}
            color={"default"}
            avatar={<Avatar src={reviewer.avatar ?
              `data:${reviewer.avatar?.imageType || ''};base64, ${reviewer.avatar?.imageData || ''}`
              :
              "/terraform-avatar.png"
            } />}
            deleteIcon={reviewer.vote > 0 ? <CheckCircleIcon /> : reviewer.vote === 0 ? <RadioButtonUncheckedIcon /> : <CancelIcon />}
            onDelete={() => {}}
            label={reviewer.name}
          />
        </Tooltip>
      </Stack>
    ))
  }
  </>;
}

export default ReviewStatusChip;
